import {
  PageHeaderWrapper,
  PageHeaderWrapperDiv,
} from "styles/jss/Layout.styles";
import { Container } from "@mui/material";
import { getImageUrl, isEmpty } from "utils/helperFunction";

export default function PageHeader({ as, title, banner }) {
  const handleBG = !isEmpty(banner)
    ? {
        bgImage: `${process.env.BASE_URL}${
          getImageUrl(banner, ["large", "medium"])?.url
        }`,
      }
    : {};

  return (
    <>
      {as === "header" ? (
        <PageHeaderWrapper {...handleBG}>
          <Container>
            <h1 className="title">{title}</h1>
          </Container>
        </PageHeaderWrapper>
      ) : (
        <PageHeaderWrapperDiv {...handleBG} />
      )}
    </>
  );
}
